import { SELECTED_FEATURE_COLOR, TARGET_STROBE_OPACITY } from '@utils/map/map.constants';
import { SHOW_TARGET_STROBE_MAX_ZOOM } from '@utils/map/mapZoom.constants';
import { FillLayerSpecification, LineLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const polygonLocationOutlineLayer: LineLayerSpecification = {
  id: LayerNameEnum.POLYGON_LOCATION_OUTLINES,
  type: 'line',
  source: SourceNameEnum.POLYGONS,
  maxzoom: SHOW_TARGET_STROBE_MAX_ZOOM,
  filter: ['==', 'featureType', FeatureTypeEnum.POLYGON_LOCATION_OUTLINE],
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': [
      'case',
      ['boolean', ['feature-state', 'isSelected'], false],
      SELECTED_FEATURE_COLOR,
      ['get', 'color'],
    ],
    'line-width': ['get', 'width'],
    'line-opacity': ['get', 'opacity'],
  },
};

export const polygonTrajectoryOutlineLayer: LineLayerSpecification = {
  id: LayerNameEnum.POLYGON_TRAJECTORY_OUTLINES,
  type: 'line',
  source: SourceNameEnum.POLYGONS,
  maxzoom: SHOW_TARGET_STROBE_MAX_ZOOM,
  filter: ['==', 'featureType', FeatureTypeEnum.POLYGON_TRAJECTORY_OUTLINE],
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': [
      'case',
      ['boolean', ['feature-state', 'isSelected'], false],
      SELECTED_FEATURE_COLOR,
      ['get', 'color'],
    ],
    'line-width': ['get', 'width'],
    'line-opacity': ['get', 'opacity'],
  },
};

export const polygonLocationLayer: FillLayerSpecification = {
  id: LayerNameEnum.POLYGON_LOCATIONS,
  type: 'fill',
  source: SourceNameEnum.POLYGONS,
  maxzoom: SHOW_TARGET_STROBE_MAX_ZOOM,
  filter: ['==', 'featureType', FeatureTypeEnum.POLYGON_LOCATION],
  paint: {
    'fill-color': [
      'case',
      ['boolean', ['feature-state', 'isSelected'], false],
      SELECTED_FEATURE_COLOR,
      ['get', 'color'],
    ],
    'fill-opacity': TARGET_STROBE_OPACITY,
  },
};
